import React from "react";
import { Trans } from "react-i18next";
import { Button } from "semantic-ui-react";
import { IModalActions, IModalActionsDelete, IModalActionsReset, IModalActionsYesNoCancelProps } from "./modalActions.d";

export const ModalActions = ({ showModal, onCancel, onSave, saveLabel, disable, disabled, loading }: IModalActions) => (
  <>
    <Button
      data-test="modalCancel"
      onClick={() => {
        if (onCancel) onCancel();
        showModal(false);
      }}
    >
      <Trans i18nKey="form.cancel" />
    </Button>
    <Button
      primary
      data-test="modalConfirm"
      onClick={onSave}
      disabled={disable || disabled}
      loading={loading || disabled}
      icon="save outline"
      content={saveLabel || <Trans i18nKey="form.save" />}
    />
  </>
);

export const ModalActionsClose = ({ showModal }: Pick<IModalActions, "showModal">) => (
  <Button onClick={() => showModal(false)}>
    <Trans i18nKey="form.cancel" />
  </Button>
);

export const ModalActionsReset = ({ onReset }: IModalActionsReset) => (
  <Button onClick={() => { onReset?.(); }}>
    <Trans i18nKey="form.reset" />
  </Button>
);

export const ModalActionsDelete = ({
  showModal,
  onSave,
  onCancel,
  onDelete,
  saveLabel,
  disable,
  disabled,
  loading
}: IModalActionsDelete) => (
  <>
    <Button
      onClick={() => {
        if (onCancel) onCancel();
        showModal(false);
      }}
      content={<Trans i18nKey="form.cancel" />}
    />
    <Button onClick={onDelete} color="red" content={<Trans i18nKey="form.delete" />} />
    <Button
      primary
      onClick={onSave}
      disabled={disable || disabled}
      loading={loading || disabled}
      icon="save outline"
      content={saveLabel || <Trans i18nKey="form.save" />}
    />
  </>
);

export const ModalActionsYesNoCancel = ({
  showModal,
  onSave,
  onCancel,
  onNo,
  saveLabel,
  disabled,
  loading
}: IModalActionsYesNoCancelProps) => (
  <>
    <Button
      onClick={() => {
        if (onCancel) onCancel();
        showModal(false);
      }}
      content={<Trans i18nKey="form.cancel" />}
    />
    <Button onClick={onNo} color="red" content={<Trans i18nKey="form.no" />} />
    <Button
      primary
      onClick={onSave}
      disabled={disabled}
      loading={loading || disabled}
      icon="save outline"
      content={saveLabel || <Trans i18nKey="form.save" />}
    />
  </>
);

export default ModalActions;
